import React, { Component } from 'react';
import { Button, TextField, CardContent, Typography, FormControlLabel, Switch } from '@material-ui/core';
import api from '../../../services/api';
import AlertInformation from 'components/AlertInformation/AlertInformation';
import { ANAO, ASIM } from 'consts';

class GrupoMsgWhatsAppFornecedorForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            grupomensagem: {},
            isNewRecord: false,
            isView: false
        };
    };

    async componentDidMount() {
        // carrega informações formulário
        const { id } = this.props.match.params;
        const { location } = this.props;
        const currentPath = location.pathname;

        if (id >= 0) {
            const response = await api.get(`/whatsapp/grupomensagemfornecedor/${id}`);
            this.setState({
                grupomensagem: response.data[0],
                isNewRecord: false,
                isView: (currentPath.includes('/view'))
            }
            );
        }
        else if (id === 'novo') {
            this.setState({
                isNewRecord: true
            });
            this.state.isNewRecord = true;
            const { grupomensagem } = this.state;
        }
    }

    /* evento on change componentes */
    OnChange = (event) => {
        const { grupomensagem } = this.state;
        const { name, type, value, checked } = event.target;
        let adjustedValue = value;

        switch (type) {
            case 'checkbox':
                if (name === 'inativo') {
                    if (checked === false) {
                        adjustedValue = ASIM;
                    }
                    else {
                        adjustedValue = ANAO;
                    }
                }
                break;
            default:
                adjustedValue = value.toUpperCase();
                break;
        }

        grupomensagem[name] = adjustedValue;
        this.setState({ grupomensagem: grupomensagem });
    };

    onClickSave = () => {
        if (this.validationRequiredFields()) {
            if (this.state.isNewRecord) {
                this.insereGrupoMensagem()
            }
            else {
                this.atualizaGrupoMensagem();
            }
        }
    };

    onClickCancel = () => {
        this.props.history.push('/crm/grupomsgwhatsappfornecedor');
    };

    validationRequiredFields() {
        const { grupomensagem } = this.state;
        let retorno = true;

        if ((String(grupomensagem.nome).trim() === '') || (grupomensagem.nome === undefined)) {
            grupomensagem.nome = '';
            this.setState({ grupomensagem: grupomensagem });
            retorno = false;
        };

        return retorno;
    };

    insereGrupoMensagem = async () => {
        const { grupomensagem } = this.state;
        grupomensagem.codusuarioregistrou = parseInt(sessionStorage.getItem('codUser'));
        try {
            const response = await api.post(`/whatsapp/grupomensagemfornecedor`, grupomensagem);
            if (response.status === 200) {
                this.props.history.push('/crm/grupomsgwhatsappfornecedor');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    };

    atualizaGrupoMensagem = async () => {
        const { grupomensagem } = this.state;
        try {
            const response = await api.put(`/whatsapp/grupomensagemfornecedor/${grupomensagem.idgrupomsgwhats}`, grupomensagem);
            if (response.status === 200) {
                this.props.history.push('/crm/grupomsgwhatsappfornecedor');
            }
        } catch (error) {
            this.handleOpenAlert(error.response.data.error);
        }
    }

    /* abre janela de alerta com mensagem */
    handleOpenAlert = (message) => {
        this.setState({ openAlert: true });
        this.setState({ messageAlert: message });
    };

    /* fecha janela mensagem alerta */
    handleCloseAlert = () => {
        this.setState({ openAlert: false });
    };

    render() {
        const { grupomensagem } = this.state;

        return (
            <div>
                <CardContent>
                    <Typography
                        component="h1"
                        variant="h3"
                    >
                        Grupo de mensagens {grupomensagem.idgrupomsgwhats}
                    </Typography>

                    <br />

                    <TextField
                        label="Nome do grupo de mensagens"
                        name="nome"
                        value={grupomensagem.nome || ''}
                        variant="outlined"
                        onChange={this.OnChange}
                        helperText={grupomensagem.nome === '' ? 'Nome do grupo obrigatório' : ' '}
                        disabled={this.state.isView}
                        inputProps={{ maxLength: 100 }}
                        fullWidth
                    />

                    <FormControlLabel
                        control={
                            <Switch
                                checked={!(grupomensagem.inativo === ASIM)}
                                name={"inativo"}
                                onChange={this.OnChange}
                                color="primary"
                                disabled={this.state.isView}
                            />
                        }
                        label={(grupomensagem.inativo === ASIM) ? 'Inativo' : 'Ativo'}
                    />

                    <br />
                    <br />

                    <Button
                        name="salvar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickSave}
                        style={{ marginTop: '10px' }}
                        disabled={this.state.isView}
                    >
                        Salvar
                    </Button>

                    <Button
                        name="cancelar"
                        color="primary"
                        variant="contained"
                        onClick={this.onClickCancel}
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                    >
                        Cancelar
                    </Button>
                </CardContent>

                <AlertInformation
                    open={this.state.openAlert}
                    handleClose={() => this.handleCloseAlert()}
                    message={this.state.messageAlert}
                />
            </div>
        );
    }
}

export default GrupoMsgWhatsAppFornecedorForm;